export const SET_WITH_REVISIONS = 'SET_WITH_REVISIONS';
export const SET_WITH_PRE_REVISIONS = 'SET_WITH_PRE_REVISIONS';
export const SHOW_PDF_VIEWER = 'SHOW_PDF_VIEWER';
